module.exports = __webpack_require__.p + "90dc8af4c49691fb2d8f6409bbcfcab4.jpg";